var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export var isCircleComp = function (iterator) {
    return iterator === null || iterator === void 0 ? void 0 : iterator.isCircleComp;
};
var RenderStore = /** @class */ (function () {
    function RenderStore(rootStore) {
        var _this = this;
        this.actions = {};
        this.bindedActions = {};
        /**
         * @description: 获取指定id的store
         * @param {number} key storeId
         * @return {any}
         */
        this.getSchemaStore = function (key) {
            var _a = _this, state = _a.state, bindedActions = _a.bindedActions;
            // schemaStore 平铺了组件的state和actions
            var schemaStore = __assign(__assign(__assign({}, state[key]), bindedActions[key]), { key: key });
            return schemaStore;
        };
        this.rootStore = rootStore;
    }
    Object.defineProperty(RenderStore.prototype, "state", {
        get: function () {
            return this.rootStore.getState();
        },
        enumerable: false,
        configurable: true
    });
    RenderStore.prototype.bindAction = function (key, action, iterator) {
        var rootStore = this.rootStore;
        var nextComponentState = {};
        var updateState = function () {
            var _a, _b;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var state = rootStore.getState();
            var ret = action.apply(void 0, __spreadArray([state[key]], __read(args)));
            var newState = (ret === null || ret === void 0 ? void 0 : ret.then) ? ret.then() : ret; // 判断是否是异步
            if (isCircleComp(iterator)) {
                // 被循环组件需要加到对应key的数组位置
                nextComponentState = __assign(__assign(__assign({}, state[key]), newState), (_a = {}, _a["" + (iterator === null || iterator === void 0 ? void 0 : iterator.index)] = __assign(__assign({}, state[key][iterator === null || iterator === void 0 ? void 0 : iterator.index]), newState), _a));
            }
            else {
                nextComponentState = __assign(__assign({}, state[key]), newState);
            }
            rootStore.setState(__assign(__assign({}, state), (_b = {}, _b[key] = nextComponentState, _b)));
        };
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            updateState.apply(void 0, __spreadArray([], __read(args)));
            return nextComponentState;
        };
    };
    RenderStore.prototype.registerSchemaStore = function (store, instance) {
        var _a = this, state = _a.state, actions = _a.actions;
        var key = instance.key;
        // 初始化state
        // state 拉平
        try {
            state[key] = typeof store.state === 'function' ? store.state(instance) : JSON.parse(JSON.stringify(store.state));
        }
        catch (e) {
            state[key] = {};
        }
        // 初始化actions
        try {
            actions[key] = typeof store.actions === 'function' ? store.actions(instance) : store.actions;
        }
        catch (e) {
            actions[key] = {};
        }
    };
    /** 注册循环store */
    RenderStore.prototype.registerCircleSchemaStore = function (store, instance, iterator) {
        var state = this.state;
        var key = instance.key;
        /**
         * 为循环组件创建storestate，放在对应key的state数组中
         * eg: 3:[{a: 1},{a: 2}]
         */
        if (state[key] && !state[key][iterator.index]) {
            try {
                state[key][iterator.index] =
                    typeof store.state === 'function' ? store.state(instance) : JSON.parse(JSON.stringify(store.state));
            }
            catch (e) {
                state[key][iterator.index] = {};
            }
        }
    };
    /**
     * 获取注册的对应key的store
     */
    RenderStore.prototype.getStoreActionsByKey = function (key) {
        return this.bindedActions[key];
    };
    /**
     * @description: 获取指定父节点name的store
     * @param {instance} ComponentInstance
     * @param {string} name
     * @return {any[]} store
     */
    RenderStore.prototype.getParentSchemaStores = function (instance, name) {
        var schemaStores = [];
        var nameRegExp = new RegExp(name + "$");
        var parent = instance.parent;
        while (parent) {
            var parentKey = parent.key, parentName = parent.name;
            // 不传name则表示只获取上一级 || 父级是否指定的name或以name结尾的（兼容类似xxxForm这样的业务场景）
            if (!name || nameRegExp.test(parentName)) {
                var schemaStore = this.getSchemaStore(parentKey);
                schemaStores.push(schemaStore);
            }
            parent = parent.parent;
        }
        return schemaStores;
    };
    return RenderStore;
}());
export { RenderStore };
//# sourceMappingURL=store.js.map